// SLAYER always lives on long after he's gone.
//
angular.module('dealerware.web.data').factory('DealerwareExpensesModel', function ($http, Model, DataUtils) {

    var dataUtils = DataUtils.getInstance();

    var billableItemPrefix = 'Billing::BillableItems::';

    var model = new Model(
        {
            baseEndpoint: '/locations/:location_id/billable_items',
            customActions: {

                getExpenses: {
                    method: 'GET',
                    rootNode: 'billable_items',
                    responseFormatter: {
                        format: function (response) {
                            return mapBillableItems(response);
                        }
                    }
                },

                saveExpenses: {
                    method: 'POST',
                    ignoreAssociations: true
                }
            },

            requestTransforms: new function() {

                this.saveExpenses = function (args, data) {

                    var origData = angular.extend({ }, data.billable_item);

                    Object.keys(data).forEach(function (key) {
                        delete data[key];
                    });

                    var mungedValue = parseFloat(dataUtils.unformatDecimalNumber(origData.value || '0')) === 0 ?
                        0 : origData.value;

                    angular.extend(data, {
                        id      : origData.id,
                        taxable : mungedValue === 0 ? false : origData.taxable,
                        name    : origData.expenseInputText,
                        type    : origData.type,
                        value   : mungedValue
                    });

                    if (data.taxable && data.type.indexOf(billableItemPrefix + 'Taxes::') === -1) {
                        data.applicable_tax_types = ['Billing::BillableItems::Taxes::SalesTax'];
                    }
                };
            },

            responseTransforms: new function() {

                this.getExpenses = function (args, data) {

                    data.map( function (section) {

                        if (section.value === null) {
                            section.valueOriginal = section.value = 0;
                        }

                        if (section.value != 0) {
                            section.chosen = true;
                        }
                        else {
                            section.chosen = false;
                        }
                    });
                };

                this.saveExpenses = function (args, data) {

                    var valueMunged = data.value || '0';

                    var origData = angular.extend({ }, data);

                    Object.keys(data).forEach(function (key) {
                        delete data[key];
                    });

                    data.type = origData.type;
                    data.chosen = (valueMunged != 0);

                    if (data.type.indexOf(billableItemPrefix + 'Taxes::') !== -1) {
                        angular.extend(data, {
                            valueDisplay    : dataUtils.formatPercentage(valueMunged, {
                                decimalPlaces: 3
                            }),
                            valueOriginal   : origData.value
                        });
                    }
                    else {
                        angular.extend(data, {
                            valueDisplay    : dataUtils.formatCurrency(valueMunged),
                            valueOriginal   : origData.value,
                            taxable         : origData.taxable,
                            taxableOriginal : origData.taxable
                        });
                    }
                };
            },

            params: undefined,
            responseFormatter: undefined,
            associationMapper: undefined,
            rootNodeRequest: undefined
        }
    );

    jQuery.extend(model, { });

    function mapBillableItems (response) {

        var filteredItemTypes = [

            {
                type               : billableItemPrefix + 'Taxes::SalesTax',
                fieldName          : 'taxSalesTax',
                hasTaxable         : true,
                chosen             : true,
                value              : 0,
                valueOriginal      : 0,
                valueDisplay       : '0.000%',
                expenseChoiceLabel : 'What is your sales tax?',
                expenseInputText   : 'Sales Tax'
            },

            {
                type               : billableItemPrefix + 'Fuel::FuelPrice',
                fieldName          : 'fuelFuelPrice',
                chosen             : false,
                value              : 0,
                valueOriginal      : 0,
                valueDisplay       : '$0.00',
                taxable            : false,
                taxableOriginal    : false,
                expenseChoiceLabel : 'Do you want to charge for fuel per gallon?',
                expenseInputText   : 'Fuel Charge'
            },

            {
                type               : billableItemPrefix + 'Fuel::ServiceCharge',
                fieldName          : 'fuelServiceCharge',
                chosen             : false,
                value              : 0,
                valueOriginal      : 0,
                valueDisplay       : '$0.00',
                taxable            : false,
                taxableOriginal    : false,
                expenseChoiceLabel : 'Do you want to charge a fuel convenience fee?',
                expenseInputText   : 'Fuel Service Charge'
            },

            {
                type               : billableItemPrefix + 'Rates::Daily',
                fieldName          : 'ratesDaily',
                chosen             : false,
                value              : 0,
                valueOriginal      : 0,
                valueDisplay       : '$0.00',
                taxable            : false,
                taxableOriginal    : false,
                expenseChoiceLabel : 'Do you want to charge a loaner vehicle daily rate?',
                expenseInputText   : 'Daily Rate'
            }
        ];

        var filteredItemTypesMap = { };
        filteredItemTypes.map(function (item, index) {
            filteredItemTypesMap[item.type] = index;
        });

        response.data

            .map( function (item) {

                var extendedItem = angular.extend(
                    filteredItemTypes [ filteredItemTypesMap[item.type] ], item
                );

                // Start out with the tax value formatted the same way the formatter on the
                // input would have it.
                //
                extendedItem.value = dataUtils.formatDecimalNumber(
                    { decimalPlaces          : extendedItem.hasTaxable ? 3 : 2 }
                ).formatter(extendedItem.value);

                var valueMunaged = extendedItem.value || '0';

                if (extendedItem.hasTaxable) {
                    extendedItem.valueDisplay    = dataUtils.formatPercentage(valueMunaged, {
                        decimalPlaces: 3
                    });
                    extendedItem.valueOriginal   = extendedItem.value;
                }
                else {
                    extendedItem.valueDisplay    = dataUtils.formatCurrency(valueMunaged);
                    extendedItem.valueOriginal   = extendedItem.value;
                    extendedItem.taxable         = extendedItem.value === 0 ? false : extendedItem.taxable;
                    extendedItem.taxableOriginal = extendedItem.taxable;
                }
            });

        return filteredItemTypes;
    }

    return model;
});

/*
 .config(function($provide) {
 $provide.decorator('LoanerAgreementModel', function($delegate, $injector) {
 return $injector.get('DealerwareLoanerAgreementModel');
 });
 });
 */
